// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".distribution .el-input[data-v-1be09996] {\n  width: 300px;\n}\nspan[data-v-1be09996] {\n  word-break: keep-all;\n  font-size: 13px;\n  margin-left: 10px;\n}", ""]);
// Exports
module.exports = exports;
